import React from 'react';
import { ShoppingBag } from 'phosphor-react';

interface OrderBadgeProps {
  orderId?: number;
  status?: 'pending' | 'ready';
  onClick?: (e: React.MouseEvent) => void;
  size?: 'sm' | 'md';
  className?: string;
}

export const OrderBadge: React.FC<OrderBadgeProps> = ({
  orderId,
  status = 'pending',
  onClick,
  size = 'sm',
  className = ''
}) => {
  if (!orderId) {
    return null;
  }

  const statusLabel = status === 'ready' ? 'Lista' : 'Pendiente';
  const statusColor = status === 'ready'
    ? 'bg-green-100 text-green-700'
    : 'bg-yellow-100 text-yellow-800';

  const isSm = size === 'sm';

  return (
    <button
      onClick={onClick}
      className={`
        flex items-center gap-1 shrink-0 transition-colors duration-200
        hover:opacity-80 active:scale-95 rounded-full
        ${statusColor}
        ${isSm ? 'px-2 py-0.5' : 'px-3 py-1'}
        ${className}
      `}
      aria-label={`Orden ${orderId}: ${statusLabel}`}
    >
      <ShoppingBag size={isSm ? 12 : 14} weight="bold" />
      <span className={`font-sans font-medium tracking-[-0.12px] whitespace-nowrap ${
        isSm ? 'text-xs' : 'text-sm'
      }`}>
        Orden {statusLabel}
      </span>
    </button>
  );
};

export default OrderBadge;
